module.exports = __webpack_public_path__ + "static/a-head-full-of-ghosts-7b3a1ac84dce7a6cac562dd5b68c08a6.jpg";